import { render, staticRenderFns } from "./RegistroNovedadDialogComponent.vue?vue&type=template&id=06f11ce6&scoped=true"
import script from "./RegistroNovedadDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroNovedadDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistroNovedadDialogComponent.vue?vue&type=style&index=0&id=06f11ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f11ce6",
  null
  
)

export default component.exports